import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { CheckSquare } from "lucide-react";
import { PageHeader } from "@/components/common/PageHeader";
import { EmptyState, LoadingBlock } from "@/components/common/States";
import { AppList, AppRow } from "@/components/common/Motion";
import api from "@/lib/api";

export default function Approvals() {
  const [items, setItems] = useState(null);
  // Entrance runs once; approving a post refetches the queue and should not
  // replay it. A ref, so it flips after the first paint rather than with it.
  const hasRendered = useRef(false);
  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/posts/approvals/queue"); setItems(data.items); }
      catch { setItems([]); }
    })();
  }, []);
  useEffect(() => { if (items) hasRendered.current = true; }, [items]);

  return (
    <div>
      <PageHeader title="Approvals" subtitle="Posts waiting for your review." />
      <div className="rounded-xl border border-[#E4E9EF] bg-white">
        {items === null ? <div className="p-6"><LoadingBlock rows={4} /></div> :
          items.length === 0 ? <div className="p-8"><EmptyState icon={CheckSquare} title="You're all caught up" body="No posts waiting on you right now." /></div> :
            <AppList as="ul" settled={hasRendered.current} className="divide-y divide-[#E4E9EF]">
              {items.map(p => (
                <AppRow as="li" key={p.id} className="flex items-center justify-between p-4">
                  <div className="min-w-0">
                    <Link to={`/app/composer/${p.id}`} className="text-sm font-semibold text-[#0B2B33] hover:underline" data-testid={`approval-title-${p.id}`}>{p.title}</Link>
                    <div className="mt-1 text-xs text-[#8A97A0]">
                      Submitted {new Date(p.updated_at).toLocaleString()} · {(p.variants || []).map(v => v.network).join(" · ")}
                    </div>
                  </div>
                  <Link to={`/app/composer/${p.id}`} data-testid={`approval-review-${p.id}`} className="hs-btn-primary text-sm">Review</Link>
                </AppRow>
              ))}
            </AppList>
        }
      </div>
    </div>
  );
}
